import { makeAutoObservable } from "mobx";
import { deepHasUnavailabilityReason, } from "../ordering";
import { PPrice } from "./PPrice";
import { ProductInstancePrice } from "../pricing/ProductInstancePrice";
export class PProductInstanceVariant {
    constructor(params) {
        this.instance = params.instance;
        this._creator = params.creator;
        this.purchaseOrderPayload = params.purchaseOrderPayload;
        this.variantParameterChoiceName = params.variantParameterChoiceName;
        this.localizationProvider = params.localizationProvider;
        makeAutoObservable(this);
    }
    creator() {
        return this._creator();
    }
    get isAvailable() {
        const { availability } = this.instance;
        return (availability.isAvailable.isPossible ||
            // FIXME this is temporary legacy compatibility fix, remove whenever possible
            deepHasUnavailabilityReason("Preorder", availability));
    }
    get inCartQuantity() {
        return this.purchaseOrderPayload.cartCount(this.instance).value;
    }
    get price() {
        return new PPrice(this.localizationProvider, ProductInstancePrice.price(ProductInstancePrice.priceSelector(this.instance)).spectrum);
    }
}
